<template>
  <div
    class="flex flex-col h-full items-center justify-center border rounded bg-gray-100 p-4"
  >
    <el-image class="banner-image" :src="bannerImage" fit="contain" />
    <div
      class="text-lg text-center text-th-secondary font-bold mb-2"
      data-testid="ai-chat-banner-title"
    >
      {{ t('aichat.main.banner.title') }}
    </div>
    <div
      class="text-sm text-center text-th-secondary-gray mb-4"
      data-testid="ai-chat-banner-description"
    >
      {{ t('aichat.main.banner.description') }}
    </div>
    <ul class="flex flex-col items-left gap-2 mb-4 points">
      <li v-for="point in POINTS" :key="point.key" class="inline-flex flex-row">
        <span class="text-th-primary mr-2"><component :is="point.icon" /></span>
        <span class="text-sm">{{ t(point.key) }}</span>
      </li>
    </ul>
    <el-button type="primary" data-testid="ai-chat-banner-contact-button">
      {{ t('aichat.main.banner.button.contact_us') }}
    </el-button>
  </div>
</template>

<script setup lang="ts">
import { useI18n } from 'vue-i18n'
import bannerImage from '@shared/assets/images/ai-chat/subscribe-banner.png'
import {
  BoxIcon,
  SettingsIcon,
  SimpleChartIcon,
  StaffTypeIcon
} from '@shared/assets/icons'

const POINTS = [
  { key: 'aichat.main.banner.point_1', icon: SimpleChartIcon },
  { key: 'aichat.main.banner.point_2', icon: BoxIcon },
  { key: 'aichat.main.banner.point_3', icon: StaffTypeIcon },
  { key: 'aichat.main.banner.point_4', icon: SettingsIcon }
] as const

const { t } = useI18n()
</script>

<style scoped>
.banner-image {
  width: 10rem;
  margin-bottom: 1rem;
}

.points {
  width: 80%;
}
</style>
